import { render, staticRenderFns } from "./BuyerSpaceTimeline.vue?vue&type=template&id=40c5826e&"
import script from "./BuyerSpaceTimeline.vue?vue&type=script&lang=js&"
export * from "./BuyerSpaceTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports